export default __webpack_public_path__ + "static/media/diamond-wheel-two.4587b62c.svg";